
















import { Component, Vue, Watch } from 'vue-property-decorator';
import SupportedContext from '@/types/SupportedContext';
import SearchDefaults from '@/types/SearchDefaults';
import FilterContextData from '@/models/FilterContextData';
import { FilterGetter } from '@/store/getters';
import { FilterAction } from '@/store/actions';

@Component({
  name: 'search-context-selection-component',
})
export default class SearchContextSelectionComponent extends Vue {
  private selectedContext: SupportedContext = SearchDefaults.searchContext;

  private get searchContexts(): Array<SupportedContext> {
    return this.$store.getters[FilterGetter.SearchContexts];
  }

  private get activeSearchContext(): SupportedContext {
    return this.$store.getters[FilterGetter.ActiveSearchContext];
  }

  private appendCounterSuffix(searchContext: SupportedContext): string {
    const data: FilterContextData | undefined = this.$store.getters[FilterGetter.SearchContextsData]
      .get(searchContext);
    return data !== undefined && !data.loading ? `(${data.numberOfResults})` : '';
  }

  @Watch('activeSearchContext')
  private storeActiveSearchContext(newValue: SupportedContext) {
    this.selectedContext = newValue;
  }

  private switchSearchContext(): void {
    if (this.activeSearchContext !== this.selectedContext) {
      this.$store.dispatch(FilterAction.SwitchSearchContext, {
        searchContext: this.selectedContext,
      });
    }
  }
}
